import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { ApiResponse } from './../../../core/models/response-api';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Consultant } from './../../../core/models/Consultant';

@Injectable({
  providedIn: 'root',
})
export class IntervenantService extends CrudService<
  ApiResponse<any>,
  number
> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }


  getAllIntervenants(): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/Employee/getListActiveEmployee`);
  }
}
